module.exports = __webpack_public_path__ + "img/05.da79489b.png";